/**
 * TaskPoolModal Context
 * Context and hook for opening the Task Pool modal from anywhere in the tree.
 */

import { createContext, useContext } from 'react';

export interface TaskPoolModalContextValue {
  openModal: (column?: string) => void;
}

export const TaskPoolModalContext = createContext<TaskPoolModalContextValue | null>(null);

export function useOpenTaskPoolModal() {
  const ctx = useContext(TaskPoolModalContext);
  if (!ctx) {
    throw new Error('useOpenTaskPoolModal must be used within TaskPoolModalProvider');
  }
  return ctx.openModal;
}
